/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".document-container[_ngcontent-%COMP%]{margin-bottom:5rem;padding:0 1rem}.positionLeft[_ngcontent-%COMP%]{float:left}.alignSentenceReject[_ngcontent-%COMP%]{padding-bottom:.5rem}"];
export { styles as styles };
